@if ((activities$ | async)?.length) {
  <app-pagination-menu
    [pageSize]="pageSize$ | async"
    [currentPage]="pageNumber$ | async"
    (pageSizeChange)="pageSize$.next($event)"
    (currentPageChange)="pageNumber$.next($event)"
    [numberOfRecords]="totalActivities$ | async"
  ></app-pagination-menu>
}

<app-activity-table
  [activities]="activities$ | async"
  [columns]="columns"
  [hiddenFields]="hiddenFields"
  [hasPagination]="false"
  [useServerSideFilters]="true"
  [activitySearchFilterCounts]="activitySearchFilterCounts$ | async"
  [showDownloadButton]="true"
  (searchQueryChange)="updateSearchQuery($event)"
  (filtersChange)="updateFilters($event)"
></app-activity-table>
